import React, { useEffect } from "react";
import Html from "utils/Html";
import Func from "utils/Func";
import { Dropdown } from "semantic-ui-react";
import { useAlluser } from "context/AlluserContext";

export default function FilterLocation({ data }) {
  const { filters, storeFilters } = useAlluser();
  const filterName = "location";
  const filterTitle = "Location";
  let handleEvents = {
    SelectNone: {
      OnClick: function (evt) {
        let selectedArr = [];
        // console.log("Btn Select None => " + filterName);
        storeFilters({ ...filters, location: selectedArr });
      },
    },
    SelectAll: {
      OnClick: function (evt) {
        let selectedArr = [];
        for (const i in itemData) {
          selectedArr.push(itemData[i].value);
        }
        // console.log("Btn Select All => " + filterName, selectedArr);
        storeFilters({ ...filters, location: selectedArr });
      },
    },
    OnChange: function (evt, { name, value }) {
      // console.log(name, value);
      storeFilters({ ...filters, location: value });
    },
  };
  // useEffect(() => {}, []);
  
  let itemData = [];
  let searchObj = data;
  let n = 0;
  if ("country" in filters && filters.country.length > 0) {
    let country = filters.country;
    n = country.length;
    searchObj = Func.SearchObject(data, country, "country_code");
  }
  for (let i in searchObj) {
    let row = searchObj[i];
    if (n === 0 && row.country_code === "EXOGROUP") continue;
    let name = "";
    if ("full_city" in row) {
      name = row.full_city;
    } else {
      name = row.city;
      if (n !== 1) {
        name += " (" + row.country_code + ")";
      }
    }
    itemData.push({ name: name, value: row.city });
  }
  return (
    <div
      key={"filter-" + filterName + "-" + filters.key_form}
      className="filter-input-field select"
    >
      <Html.SelectAll handleEvents={handleEvents} />
      <label htmlFor={"filter-inp-" + filterName} className="label">
        {filterTitle}
      </label>
      <Dropdown
        fluid
        selection
        search={true}
        multiple={true}
        id={"filter-inp-" + filterName}
        name={filterName}
        placeholder={filterTitle}
        options={Html.OptionList(itemData, {
          id: "",
          key: filterName,
          name: "name",
          value: "value",
          optionGroup: false,
          optionNull: false,
        })}
        value={filters?.location ?? []}
        onChange={handleEvents.OnChange}
        disabled={false}
        className="alluser-dropdown"
      />
      <span
        className="select-helper-text hide"
        id={"helper-text-" + filterName}
      >
        {"Please select " + filterName}
      </span>
    </div>
  );
}
